import environmentConfig from "configuration/environmentConfig";
import { ContentTypesEnum } from "enums";

type ContentLinkLookup = {
  [key in ContentTypesEnum]: (id: number) => string;
};

export const getContentLinkToEup: ContentLinkLookup = {
  [ContentTypesEnum.Flows]: (id) => `${environmentConfig.eupUrl}/discover/flows/${id}`,
  [ContentTypesEnum.AllFlows]: (id) => `${environmentConfig.eupUrl}/discover/flows/${id}`,
  [ContentTypesEnum.Events]: (id) => `${environmentConfig.eupUrl}/discover/event/${id}`,
  [ContentTypesEnum.Videos]: (id) => `${environmentConfig.eupUrl}/discover/asset/${id}`,
  [ContentTypesEnum.Surveys]: (id) => `${environmentConfig.eupUrl}/discover/survey/${id}`,
  [ContentTypesEnum.Assessments]: (id) => `${environmentConfig.eupUrl}/discover/assessment/${id}`,
  [ContentTypesEnum.PDFs]: (id) => `${environmentConfig.eupUrl}/discover/pdf/${id}`,
  [ContentTypesEnum["Embedded Videos"]]: (id) => `${environmentConfig.eupUrl}/discover/asset/${id}`,
  [ContentTypesEnum.Assets]: () => "",
  [ContentTypesEnum.Links]: () => "",
  [ContentTypesEnum.Emails]: () => "",
  [ContentTypesEnum.Messages]: () => "",
  [ContentTypesEnum.Embedded]: () => "",
  [ContentTypesEnum.Uploaded]: () => "",
  [ContentTypesEnum.Campaigns]: () => "",
  [ContentTypesEnum.Scheduled]: () => "",
  [ContentTypesEnum.Scorm]: (id) => `${environmentConfig.eupUrl}/discover/scorm/${id}`,
};

export const FROM_ADMIN_QUERY_PARAM = "fromAdmin";

export const getContentLinkToEupFromPreview: ContentLinkLookup = {
  [ContentTypesEnum.Flows]: (id) => `${getContentLinkToEup[ContentTypesEnum.Flows](id)}?${FROM_ADMIN_QUERY_PARAM}=true`,
  [ContentTypesEnum.AllFlows]: (id) =>
    `${getContentLinkToEup[ContentTypesEnum.Flows](id)}?${FROM_ADMIN_QUERY_PARAM}=true`,
  [ContentTypesEnum.Events]: (id) =>
    `${getContentLinkToEup[ContentTypesEnum.Events](id)}?${FROM_ADMIN_QUERY_PARAM}=true`,
  [ContentTypesEnum.Videos]: (id) =>
    `${getContentLinkToEup[ContentTypesEnum.Videos](id)}?${FROM_ADMIN_QUERY_PARAM}=true`,
  [ContentTypesEnum.Surveys]: (id) =>
    `${getContentLinkToEup[ContentTypesEnum.Surveys](id)}?${FROM_ADMIN_QUERY_PARAM}=true`,
  [ContentTypesEnum.Assessments]: (id) =>
    `${getContentLinkToEup[ContentTypesEnum.Assessments](id)}?${FROM_ADMIN_QUERY_PARAM}=true`,
  [ContentTypesEnum.PDFs]: (id) => `${getContentLinkToEup[ContentTypesEnum.PDFs](id)}?${FROM_ADMIN_QUERY_PARAM}=true`,
  [ContentTypesEnum["Embedded Videos"]]: (id) =>
    `${getContentLinkToEup[ContentTypesEnum["Embedded Videos"]](id)}?${FROM_ADMIN_QUERY_PARAM}=true`,
  [ContentTypesEnum.Assets]: () => "",
  [ContentTypesEnum.Links]: () => "",
  [ContentTypesEnum.Emails]: () => "",
  [ContentTypesEnum.Messages]: () => "",
  [ContentTypesEnum.Embedded]: () => "",
  [ContentTypesEnum.Uploaded]: () => "",
  [ContentTypesEnum.Campaigns]: () => "",
  [ContentTypesEnum.Scheduled]: () => "",
  [ContentTypesEnum.Scorm]: (id) => `${getContentLinkToEup[ContentTypesEnum.Scorm](id)}?${FROM_ADMIN_QUERY_PARAM}=true`,
};
